<template>
	<div class="phoneAndBox" style="position:fixed;right:1vw;top:35.6%;z-index:1000;">
		<!-- <div
			v-if="phoneShowFlag===false"
			style="width:9.01vw;height:2.1875vw;background-color:#e1251b;color:#fff;border-radius: 0.5vw;line-height:2.1875vw;text-align:center;font-family:SHS-R;font-size:1.4vw;"
		>400 6688 991</div>-->

		<!-- <div class="phoneNumShowIcon" style="position:relative;z-index:6;">
			<img
				class="phone-icon"
				src="../assets/image/homePage/index/PCImage/phone.png"
				alt=""
				style="width:100%;height:100%;"
			>
		</!--> 
		<!-- <img class="phone-number" src="../assets/image/homePage/index/PCImage/phone-number.png" alt=""> -->
		<div style="" @click="scorllTop" class="scorllTopCur" :class="isShow? 'hide':''">
			<img
				src="../assets/image/homePage/index/PCImage/back-icon.png"
				alt=""
				style="width:100%;height:100%;"
			>
		</div>
	</div>
</template>
<script>
export default {
  data() {
    return {
      //   phoneShowFlag: true, //phoneBack组件
      isShow: false
    };
  },
  mounted() {
    window.addEventListener("mousewheel", this.handleScroll, false);
  },
  methods: {
    //鼠标滚动事件
    handleScroll() {
      var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
      var clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      if (scrollTop >= clientHeight - 500) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    },
    scorllTop: function() {
    //   scrollTo(0, 0);
      this.isShow = false;

      //带动画效果的回到顶部
      var timer = null;
      cancelAnimationFrame(timer);
      timer = requestAnimationFrame(function fn() {
        var oTop =
          document.body.scrollTop || document.documentElement.scrollTop;
        if (oTop > 0) {
          scrollTo(0, oTop - 300);
          timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(timer);
        }
      });
    }
    // xshPhoneNum: function() {
    //   this.phoneShowFlag = false;
    //   let _this = this;
    //   this.timeOut = setTimeout(() => {
    //     this.phoneShowFlag = true;
    //   }, 3000);
    // }
  }
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 997px) {
  .phoneAndBox {
    display: none;
  }
}
@media screen and (min-width: 998px) {
  .phoneNumShowIcon {
    height: 5.2vw;
    width: 5.2vw;
    box-shadow:0px 2px 10px 7px rgba(0,0,0,0.05);
  }
  .scorllTopCur:hover {
    cursor: pointer;
  }
  .scorllTopCur {
    height: 5.2vw;
    width: 5.2vw;
    margin-top: 1vw;
    float: right;
    // opacity: 0;
    display: none;
    box-shadow:0px 2px 10px 7px rgba(0,0,0,0.05);
    transition: all 0.5s;
  }
  .scorllTopCur.hide {
    // opacity: 1;
    display: block;
  }
  .phone-number {
    width: 13.5vw;
    height: 3.6vw;
    opacity: 0;
    transition: all 1s;
    position: absolute;
    top: 0.5vw;
    left: -14vw;
  }
  .phoneNumShowIcon:hover + .phone-number {
    opacity: 1;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/PhoneAndBack.vue